var wxPub = require('./wx_pub');

module.exports = wxPub;
